
import { IComponentType, IComponentsById, IScreenContent, ITransitionEffectTypes, ITuple3 } from "../component-data-structure";

export enum ITransCatTypes {
    enter = 'enter',
    exit = 'exit',
    hidden = 'hidden'
}

interface ISpatialTransRangeInput {
    startPosition: ITuple3,
    enterEndPosition: ITuple3,
    positionOffset?: number,
    category: ITransCatTypes, 
    effect: ITransitionEffectTypes
    sceneIsFlatImageTracked?: boolean;
}

interface ISpatialTransRangeOutput {
    from: ITuple3,
    to: ITuple3,
    threeProperty: 'scale' | 'position' | 'none'
}

type IGetSpatialTransitionRange = (input: ISpatialTransRangeInput) => ISpatialTransRangeOutput;

export const getSpatialTransitionRange: IGetSpatialTransitionRange = ({startPosition: [sx, sy, sz], enterEndPosition: [ex, ey, ez], category, effect, positionOffset = 2, sceneIsFlatImageTracked = false}) => {
    let start: ITuple3 = [sx, sy, sz];
    let end: ITuple3 = [ex, ey, ez];
    let threeProperty: 'scale' | 'position' | 'none' = 'none';
    
    switch (category) {
        case ITransCatTypes.enter: {
            switch (effect) {
                case ITransitionEffectTypes.scaleUp: {
                    start = [0, 0, 0];
                    end = [1, 1, 1];
                    threeProperty = 'scale';
                    break;
                }
                case ITransitionEffectTypes.scaleDown: {
                    start = [2, 2, 2];
                    end = [1, 1, 1];
                    threeProperty = 'scale';
                    break;
                }
                case ITransitionEffectTypes.up: {
                    start = !sceneIsFlatImageTracked ? [sx, sy - positionOffset, sz] : [sx, sy, sz - positionOffset];
					end = [ex, ey, ez];
                    threeProperty = 'position';
					break;
                }
                case ITransitionEffectTypes.down: {
					start = !sceneIsFlatImageTracked ? [sx, sy + positionOffset, sz] : [sx, sy, sz + positionOffset];
					end = [ex, ey, ez];
                    threeProperty = 'position';
					break;
                }
                case ITransitionEffectTypes.right: {
					start = [sx - positionOffset, sy, sz];
					end = [ex, ey, ez];
                    threeProperty = 'position';
					break;
                }
                case ITransitionEffectTypes.left: {
					start = [sx + positionOffset, sy, sz];
					end = [ex, ey, ez];
                    threeProperty = 'position';
					break;
                }
            }
            break;
        }
   
        case ITransCatTypes.exit: {
            switch (effect) {
                case ITransitionEffectTypes.scaleDown: {
					start = [1, 1, 1];
					end = [0, 0, 0];
                    threeProperty = 'scale';
					break;
                }
                case ITransitionEffectTypes.scaleUp: {
					start = [1, 1, 1];
					end = [2, 2, 2];
                    threeProperty = 'scale';
					break;
                }
                case ITransitionEffectTypes.up: {
					start = [sx, sy, sz];
					end = !sceneIsFlatImageTracked ? [sx, sy + positionOffset, sz] : [sx, sy, sz + positionOffset];
                    threeProperty = 'position';
					break;
                }
                case ITransitionEffectTypes.down: {
					start = [sx, sy, sz];
					end = !sceneIsFlatImageTracked ? [sx, sy - positionOffset, sz] : [sx, sy, sz - positionOffset];
                    threeProperty = 'position';
					break;
                }
                case ITransitionEffectTypes.right: {
					start = [sx, sy, sz];
					end = [sx + positionOffset, sy, sz];
                    threeProperty = 'position';
					break;
                }
                case ITransitionEffectTypes.left: {
					start = [sx, sy, sz];
					end = [sx - positionOffset, sy, sz];
                    threeProperty = 'position';
					break;
                }
            }
            break;
        }
    }

    return {from: start, to: end, threeProperty}
}

export const getOpacityTransitionRange = (category: ITransCatTypes): {from: 1 | 0, to: 1 | 0} => {
	const from = category === ITransCatTypes.enter ? 0 : 1;
	const to = category === ITransCatTypes.enter ? 1 : 0;
	return { from, to };
};

export const getScreenRelativeComponentIdsByScreenContentId = (screenContentId: string, componentsById: IComponentsById) =>{
    const sceneContent = componentsById[screenContentId] as IScreenContent;
    return sceneContent.children.reduce((screenContentIds, anchorId) => {
        const child = componentsById[anchorId];
        if (child.type === IComponentType.ScreenAnchorGroup) {
            screenContentIds.push(...child.children);
        }
        return screenContentIds;
    }, [] as string[])
}